<script setup lang="ts">
import SearchAndSortWindow from "@/components/CvrConvert/VehiclesListParts/SearchAndSortWindow.vue"
import { Ref, ref, computed } from 'vue';

const emits = defineEmits(['update:modelValue', 'changeSortType', 'closeWindow', 'search', 'setIsAllSelected'])

type selectableItemType = {
  id: string | number;
  key: string;
  label: string;
}
const props = withDefaults(
  defineProps<{
    width: number | null
    modelValue: string[]
    items: selectableItemType[]
    windowKey: string
  }>(),
  {
    width: 100
  }
)

const selectedItems: Ref<{[key: string]: boolean}> = ref(setSelectedItems(props.modelValue))

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

function setSelectedItems(value: string[]) {
  const statuses: { [key: string]: boolean; } = {}
  if (!props.items || props.items.length === 0) {
    return statuses;
  }
  props.items.forEach((selectableStatus: selectableItemType) => {
    const status = value.includes(selectableStatus.key)
    statuses[selectableStatus.id] = status
  })
  return statuses
}

function plasticSurgeryStringArray(value: {[key: string]: boolean}) {
  const statuses: string[] = []
  props.items.forEach((selectableStatus: selectableItemType) => {
    if (value[selectableStatus.id]) {
      statuses.push(selectableStatus.key)
    }
  })
  return statuses
}

function setSelectAll(status: boolean) {
  props.items.forEach((selectableStatus: selectableItemType) => {
    selectedItems.value[selectableStatus.id] = status
  })
}

function closeWindow(status: boolean) {
  emits('closeWindow', status)
}

function search() {
  modelValue.value = plasticSurgeryStringArray(selectedItems.value)
  emits('search')
}

function setIsAllSelected($event: { windowKey: string; isAllSelected: boolean; }) {
  emits('setIsAllSelected', $event);
}
</script>
<template>
  <SearchAndSortWindow
    :items="props.items"
    v-model="selectedItems"
    candidateLabel="label"
    :isSortable="false"
    :width="props.width"
    :windowKey="props.windowKey"
    @close="closeWindow"
    @setSelect="setSelectAll"
    @search="search"
    @setIsAllSelected="setIsAllSelected"
  />
</template>
